import React from "react";
import { useTranslation } from "react-i18next";

const HowItWorks = () => {
  const { t } = useTranslation();

  return (
    <section className="py-5">
      <div className="container py-4">
        <div className="row justify-content-center mb-5">
          <div className="col-md-8 text-center">
            <h2 className="fw-bold text-primary-custom mb-4">
              {t("how_platform_works")}
            </h2>
            <p className="text-muted">{t("how_platform_works_subtitle")}</p>
          </div>
        </div>

        <div className="platform-process-section bg-light p-4 p-md-5 mb-5 rounded-4">
          <div className="row g-4">
            {/* Speaker Card */}
            <div className="col-lg-6">
              <div className="card h-100 border-0 shadow-sm text-center">
                <div className="card-body">
                  {/* <h4 className="fw-bold mb-3">{t("speaker")}</h4> */}
                  <img
                    src="/assets-v2/images/UserJourney/speaker-journey.jpg"
                    alt="Speaker Journey"
                    className="img-fluid rounded"
                  />
                </div>
              </div>
            </div>

            {/* Organizer Card */}
            <div className="col-lg-6">
              <div className="card h-100 border-0 shadow-sm text-center">
                <div className="card-body">
                  {/* <h4 className="fw-bold mb-3">{t("organizer")}</h4> */}
                  <img
                    src="/assets-v2/images/UserJourney/organizer-journey.jpg"
                    alt="Organizer Journey"
                    className="img-fluid rounded"
                  />
                </div>
              </div>
            </div>

            {/* Follower Card */}
            {/* <div className="col-lg-4">
              <div className="card h-100 border-0 shadow-sm text-center">
                <div className="card-body">
                  <h4 className="fw-bold mb-3">{t("follower")}</h4>
                  <img
                    src="/assets-v2/images/UserJourney/follower-journey.jpg"
                    alt="Follower Journey"
                    className="img-fluid rounded"
                  />
                </div>
              </div>
            </div> */}
          </div>

          <div className="row mt-5">
            <div className="col-12 text-center text-lg-start">
              <div className="d-grid gap-3 d-lg-flex justify-content-lg-center">
                <a
                  href="/signup"
                  className="btn btn-outline-primary px-4 py-2 w-100 w-lg-auto"
                >
                  {t("join_as_speaker_btn")}
                </a>
                <a
                  href="/signup"
                  className="btn btn-outline-primary px-4 py-2 w-100 w-lg-auto"
                >
                  {t("join_as_Organizer_btn")}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
